<template>
  <div>
    <data-table ref="dataTable" :option="option" class="table"> </data-table>
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";
// import { jump, cache, accSub } from "@/utils/common";
// import moment from "moment";
import {
  OrderDetailModal,
  TeamOrderDetailModal
} from "@/views/orderManage/funtion.js";
import { NoStayOrderDetailModal } from "@/views/orderManage/noStayOrder/index.js";
export default {
  name: "payList",
  components: {
    DataTable
  },
  data() {
    return {
      option: {},
      defaultItem: {}
    };
  },
  created() {
    this.getDefaultItem();
    this.option = {
      headSearch: {
        width: 400,
        colnum: 1,
        content: [
          {
            label: "关键字",
            name: "KeyWord",
            colnum: 2,
            props: {
              placeholder: "关键字"
            },
            pressEnter: () => {
              setTimeout(() => {
                this.$refs.dataTable.headSearch();
              }, 100);
            }
          }
        ]
      },

      grid: {
        api: "GetInvoicePage",
        props: {
          scroll: { x: false, y: window.document.body.clientHeight - 280 }
        },
        columns: [
          {
            title: "序号",
            width: 60, //宽度
            align: "center", //对齐方式
            type: "indexcolumn" // 类型，indexcolumn = 序号
          },
          {
            title: "订单号",
            width: 100,
            dataIndex: "OrderNo",
            customRender: (text, record) => {
              if (text) {
                const jumpToOrder = {
                  click: () => {
                    this.jumpToOrder(record);
                  }
                };
                return (
                  <a-button type="link" size="small" {...{ on: jumpToOrder }}>
                    {text}
                  </a-button>
                );
              } else {
                return "";
              }
            }
          },
          {
            title: "发票类型",
            width: 100,
            dataIndex: "InvoiceTypeName"
          },
          {
            title: "发票号",
            width: 200,
            dataIndex: "InvoiceNumber"
          },
          {
            title: "开票金额",
            width: 100,
            dataIndex: "AmountMoney",
            align: "right"
          },

          {
            title: "开票人",
            width: 150,
            dataIndex: "CreatorUserName"
          },
          {
            title: "开票时间",
            width: 150,
            dataIndex: "CreationTime"
          },
          {
            title: "发票备注",
            dataIndex: "Remark"
          }
        ]
      }
    };
  },
  methods: {
    //获取系统参数值
    getDefaultItem() {
      this.$post("Room_GetDefaultTime", {}).then(res => {
        res.Data.SystemConstList.forEach(item => {
          this.defaultItem[item.Code] = item.Value;
        });
      });
    },
    jumpToOrder(record) {
      if (record.OrderId && record.OrderId != 0) {
        if (record.TypeId == 1) {
          //非住订单
          NoStayOrderDetailModal({
            orderId: record.OrderId,
            showBtn: false
          });
        } else {
          //住宿订单
          if (this.defaultItem.PlusHotelOrderModel == 1) {
            TeamOrderDetailModal({
              orderId: record.OrderId,
              showBtn: false
            });
          } else {
            OrderDetailModal({
              orderId: record.OrderId,
              showBtn: false
            });
          }
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.pay-modal {
  padding-top: 20px;
  & > div {
    margin-bottom: 10px;
    label {
      display: inline-block;
      width: 80px;
      text-align: right;
      line-height: 32px;
    }
    input {
      width: 60%;
    }
  }
}
</style>
